export const STATUS = {
  0: {
    text: '未执行',
    color: 'info'
  },
  1: {
    text: '已执行',
    color: 'success'
  }
};

export const RECORD_STATUS = {
  0: {
    text: '未发放',
    color: 'info'
  },
  1: {
    text: '已发放',
    color: 'success'
  }
};

export const PAGINATION = {
  page: 1,
  size: 25
};
